import React from 'react';
import { useTranslation } from 'react-i18next';
import { DsTag } from '@tokenyico/design-system/dist/reactJS';

const BillboardOfferStatus = ({ status = '', size, iconSize }) => {
  const { t } = useTranslation();

  if (status === 'ACTIVE') {
    return (
      <DsTag
        size={size || 'xs'}
        version="info"
        label={t('shared.active')}
        icon="triangle-right"
        iconSize={iconSize || '12px'}
      />
    );
  }

  if (status === 'COMPLETED') {
    return (
      <DsTag
        size={size || 'xs'}
        version="success"
        label={t('shared.completed')}
        icon="checkmark"
        iconSize={iconSize || '12px'}
      />
    );
  }

  if (status === 'INACTIVE') {
    return (
      <DsTag
        size={size || 'xs'}
        version="default"
        label={t('shared.inactive')}
        icon="pause"
        iconSize={iconSize || '12px'}
      />
    );
  }

  if (status === 'CANCELLED') {
    return (
      <DsTag
        size={size || 'xs'}
        version="error"
        label={t('shared.cancelled')}
        icon="close"
        iconSize={iconSize || '12px'}
      />
    );
  }
  return null;
};

export default BillboardOfferStatus;
